import { styled } from 'inlines'
import { colors } from '../../tokens/colors.js'

export const Card = styled('div', {
  flexGrow: 1,
  margin: 16,
  overflow: 'visible', // Could cause issues, set to hidden if unintended scrolling occurs
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0, // Don't change that IDK why, dragons will burn you if you do
})
